import { OsCommunicator } from '@getvim/dynamic-vim-os-sdk/sdk';
import { SdkLogger } from '@getvim/dynamic-vim-os-sdk';
import { HandshakePayload } from '@getvim/vim-os-api';

export class InternalOsCommunicator extends OsCommunicator {
  constructor(
    handshakePayload: HandshakePayload,
    osMessageChannel: MessageChannel,
    logger?: SdkLogger,
  ) {
    super(handshakePayload, osMessageChannel, logger);
  }
}
